import React from 'react';
import { PlanLink } from 'Features/Plans/PlanLink';
import { getSimplifiedPlanDisplayName } from 'Utils/Plans';
import './PlanList.css';

const PLAN_DESC = {
  'FOXNATION12M-WEB': 'Lock in the price for a full year, plus get 1 month free!',
  'FOXNATION1M-WEB2': 'Full access to Fox Nation with flexible month-to-month billing',
};

export const PlanList = ({ plans, selectedPlan, isPlanSelected, defaultPackage }) => {
  return (
    <div className="planList">
      {plans
        .filter((p) => !p.hasMerchandise)
        .map((plan, index) => {
          const { planName, planPrice, planId, planFrequencyText, hasFreePromo } = plan;
          const selectedPlanId = isPlanSelected ? selectedPlan.planId : defaultPackage;
          const isSelectedPlan = planId === selectedPlanId;
          const planDescription = (PLAN_DESC && PLAN_DESC[planId]) || '';
          const customClasses = `${planName.toLowerCase()} ${(isSelectedPlan && 'planSelected') || ''}`;
          return (
            <div className={`planListItem ${customClasses}`} key={`planListItem-${index}`}>
              <h4 className="planName">{getSimplifiedPlanDisplayName(plan)}</h4>
              <p className="planDescription">{planDescription}</p>
              {hasFreePromo && <div className="freeTrialMsg">7-Day Free Trial</div>}
              <h5 className="planPrice">
                <span className="planCurrencyLabel">$</span>
                <span className="priceVal">{planPrice}</span>
                <span className="planMonthLabel">/{planFrequencyText}</span>
              </h5>
              <div className="planButtonContainer">
                <PlanLink plan={plan} />
              </div>
            </div>
          );
        })}
    </div>
  );
};
